import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import ErrorDialog from '../../../_metronic/partials/dialogs/ErrorDialog'
import {logout} from './core/_requests'

export function Logout() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const SignOut = () => {
    logout(dispatch)
    navigate('auth/login')
  }

  return (
    <ErrorDialog
      text={'Unauthorized'}
      open={'true'}
      onConfirmDialogClose={SignOut}
    />
  )
}
